import type { MerchantDetails } from '@/modules/stores/types/get-merchant-details';

/**
 * PRATDEV-260: loja com o cardápio digital só como vitrine. Sem valor na API
 * (versão antiga), vale compra ligada.
 */
export function isShowcaseOnly(
  details?: Pick<MerchantDetails, 'ordering_enabled'> | null
): boolean {
  return details?.ordering_enabled === false;
}

/**
 * PRATDEV-260: loja do cardápio só vitrine. Diz de qual loja é a tela de sacola
 * (`/cart/review-order`) ou de checkout (`/:slug/order`); qualquer outra tela
 * (inclusive o atendimento) devolve null e não é vigiada.
 */
export function checkoutSlugFor(location: string, storedSlug: string | null): string | null {
  const path = location.split('?')[0].replace(/\/+$/, '');
  if (path === '/cart/review-order') {
    return storedSlug && storedSlug !== 'undefined' ? storedSlug : null;
  }
  const match = /^\/([^/]+)\/order$/.exec(path);
  return match ? decodeURIComponent(match[1]) : null;
}
